export const TQL_BODY_FIELD_TO_COLUMN: Record<string, string> = {
  'req.body': 'request_body',
  'req.raw': 'raw_request',
  'resp.body': 'response_body',
  'resp.raw': 'raw_response',
};

export const BODY_TQL_FIELDS = new Set(Object.keys(TQL_BODY_FIELD_TO_COLUMN));

export const RESPONSE_BODY_TQL_FIELDS = new Set(['resp.body', 'resp.raw']);
